<template>
  <div>
    <v-list-item @click="openDialog" color="primary" link>
      <v-list-item-icon>
        <v-icon color="primary">mdi-plus</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="primary--text">
          Adicionar produto
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.mobile"
      persistent
      width="500"
    >
      <v-card>
        <v-card-title>
          Adicionar produto
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="mt-2">
          <v-text-field
            v-model="search"
            label="Digite o nome do produto"
            solo
            single-line
            hide-details
            autofocus
            prepend-inner-icon="mdi-magnify"
            clearable
            :loading="loading_products"
          ></v-text-field>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-card-text class="px-1">
          <v-list>
            <div v-for="product in products" :key="product.id">
              <v-list-item @click="submit(product)" link>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ product.nome }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ product.marca }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ formatMoney(product.preco_venda) }} /
                    {{ product.unidade_medida }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { index } from "@/services/products";
import MoneyMixin from "@/mixins/MoneyMixin";

export default {
  mixins: [MoneyMixin],
  data() {
    return {
      dialog: false,
      products: [],
      search: "",
      loading_products: false
    };
  },

  methods: {
    openDialog() {
      this.dialog = true;
      this.search = "";
      this.products = [];
    },
    submit(item) {
      this.$emit("submit", item);
      this.dialog = false;
    },
    async getItems(search = "") {
      this.products = [];
      if (!search) return;

      const options = {
        sortBy: ["nome"],
        sortDesc: false,
        page: 1,
        itemsPerPage: 50
      };

      this.actual_product_page = 1;

      this.loading_products = true;
      try {
        const response = await index(options, search);
        this.products = response.data;
        this.total_items = response.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading_products = false;
      }
    }
  },

  watch: {
    search: _.debounce(async function(value) {
      await this.getItems(value);
    }, 500)
  }
};
</script>
